import React from 'react';
import { View, Text, Image } from 'react-native';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { useTranslation } from 'react-i18next';
import OrderDescription from 'types/models/OrderDescription';
import OrderItemProps from 'types/components/OrderItemProps';
import CommerceImageTypes from 'types/enums/CommerceImageTypes';
import AppContext from 'contexts/AppContext';
import { translateOrderDescription } from 'services/ordersService';
import { styles } from 'styles/components/orderItem';
import { greenColor } from 'styles/global';
import { getcolorStatusDescription } from 'utils/orders';
import { valueToCurrencyFormat } from 'utils/parseCurrency';

export default ({ order, onClickDetail }: OrderItemProps): JSX.Element => {
  const { t, i18n } = useTranslation();
  const { currentVenue } = React.useContext(AppContext);
  const imageUri =
    order.commerce.images.find((image) => image.commerceImageTypeId === CommerceImageTypes.logo)?.path ??
    'https://via.placeholder.com/100';

  const orderDescriptions: OrderDescription = {
    orderCreated: t('pending-payment'),
    orderPaymentAccepted: t('payment-accepted'),
    orderPreparing: t('preparing-order'),
    orderToDeliver: t('order-ready-to-deliver'),
    orderDelivering: t('delivering-order'),
    orderDelivered: t('order-delivered'),
    orderIncompleted: t('order-incompleted'),
    orderCanceled: t('order-canceled'),
    orderAddedToCheckingAccount: t('order-added-to-checking-account'),
  };

  return (
    <View style={styles.productInfo}>
      <View style={[styles.productInfoColumn]}>
        <Image
          style={styles.productImage}
          source={{
            uri: imageUri,
          }}
        />
      </View>
      <View style={[styles.productInfoColumn, styles.nameColumn]}>
        <View style={{ flex: 1 }}>
          <Text
            style={{
              flex: 1,
              fontStyle: 'normal',
              fontWeight: '500',
              fontSize: 14,
              lineHeight: 24,
            }}
          >
            {`${t('order-detail-number')} ${order.id}`}
          </Text>
          <Text
            style={[
              { borderColor: 'red', flex: 1, fontWeight: '500', textTransform: 'uppercase' },
              { color: getcolorStatusDescription(order.orderStatusId) },
            ]}
          >
            {translateOrderDescription(order.orderStatusId, orderDescriptions)}
          </Text>
        </View>
        <View style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
          <View style={{ flex: 2.5 }}>
            <Text
              style={{
                fontStyle: 'normal',
                fontWeight: '400',
                fontSize: 12,
                lineHeight: 20,
              }}
            >{`${order.commerce.name}`}</Text>
            <Text
              style={{
                fontStyle: 'normal',
                fontWeight: '700',
                fontSize: 14,
                lineHeight: 20,
              }}
            >
              {valueToCurrencyFormat(order.totalAmount, i18n.language)}
            </Text>
          </View>
          <View style={{ flex: 2, justifyContent: 'center', alignItems: 'center' }}>
            <TouchableOpacity
              style={[
                {
                  minWidth: 50,
                  maxWidth: 100,
                  height: 32,
                  borderRadius: 15,
                  padding: 10,
                  justifyContent: 'center',
                  alignItems: 'center',
                },
                { backgroundColor: currentVenue?.appColor ?? greenColor },
              ]}
              onPress={() => onClickDetail(order.id)}
            >
              <Text
                style={{
                  color: '#FFF',
                  fontStyle: 'normal',
                  fontWeight: '500',
                  fontSize: 14,
                  lineHeight: 20,
                }}
              >
                {t('go-to-order')}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </View>
  );
};
